<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <label>{{text}}</label>
    <table *ngIf="showContexts">
      <tr *ngFor="let context of selectableContexts"
          [class.selected]="context === selectedUiContext"
          (click)="contextSelected(context)">
        <th>{{context.name}}</th>
      </tr>
    </table>
  </div>
  <div class="modal-footer">
    <button *ngFor="let button of buttons"
            type="button"
            [class.disabled]="button.contextNeeded && !selectedUiContext"
            [qmAutofocus]="button.focus"
            (click)="buttonPressed(button.id)"
            class="btn btn-outline-dark">
      {{button.text}}
    </button>
  </div>
